/*
 * @Author: your name
 * @Date: 2020-05-07 09:53:39
 * @LastEditTime: 2020-05-12 10:40:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\public\blockly\msg\index.js  
 */
// English

import en from "./en.js";
// Chinese Simplified Handwriting
import zhHans from "./zh-hans.js";
import msgHans from "./details/zh-hans.js";
// import {gtaMsgHans} from "./details/zh-hans-gta.js";
// gtaMsgHans();
// Chinese Traditional Handwriting
import zhHant from "./zh-hant.js";

export default {
    en,
    zhHans,
    msgHans,
    zhHant
};